// extracted by mini-css-extract-plugin
export var imagewrapper = "SwiperImage-module--imagewrapper--b530a";
export var standalone = "SwiperImage-module--standalone--c5dea";